import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAllOrderData } from '@app/store/reducers/order/orderSelectors'
import { FINALIZED_WARRANTY_STATUSES } from '@app/common/constants/warranty'
import { checkPermission } from '@app/common/utils/helpers'

/**
 * Custom hook to determine warranty visibility
 * Implements the same logic as SubmissionObject.js warrantyReviewEnabled() + showWarrantyReviewTab()
 *
 * @param {Object} currentSubmission - The current submission object
 * @returns {boolean} Whether warranty section should be visible
 */
export function useWarrantyVisibility(currentSubmission) {
  const orderData = useSelector(selectAllOrderData)

  return useMemo(() => {
    if (!currentSubmission || !orderData) {
      return false
    }

    // Step 1: Check if order supports warranty at all
    const orderSupportsWarranty = orderData?.products?.some(product => product?.run_warranty_review)
    if (!orderSupportsWarranty) {
      return false
    }

    // Step 2: Check if submission has finalized warranty status
    const hasSubmissionWarranty = FINALIZED_WARRANTY_STATUSES.includes(currentSubmission?.repurchase_warranty?.status)

    // Step 3: Add permission check (same as showWarrantyReviewTab in SubmissionObject.js)
    const hasReviewPermission = checkPermission('reggora_review_view')
    return hasSubmissionWarranty && hasReviewPermission
  }, [orderData, currentSubmission])
}
